'use es6';

export const MAX_NESTING_DEPTH = 5;
export const MODULE_ASSET_EXTENSION = '.module';